import {
    isEntityDataField,
    isFieldFromFlowable,
    getConfigProperty,
    getFlowableFieldConfigProperty,
} from '../../input/fieldUtils';
import { Field } from '../../translation/types';

interface DirectionConf {
    direction?: 'HORIZONTAL' | 'VERTICAL';
}
export const getDirection = (fieldDefinition: Field) => {
    if (isEntityDataField(fieldDefinition)) {
        return getConfigProperty<DirectionConf>('direction')(fieldDefinition).getOrElse(undefined);
    }
    if (isFieldFromFlowable(fieldDefinition)) {
        return getFlowableFieldConfigProperty<DirectionConf>('direction')(fieldDefinition).getOrElse(undefined);
    }
    // no direction specified for fromFlowable
    return undefined;
};
